import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import { updateSingleFilter } from '@src/store/slices/searchFiltersSlice';

import MinMaxSelect from '@components/select/minmax-select';

// ---------------------------------------------------------

const getMinMaxId = (id) => {
  const titleCaseId = id.charAt(0).toUpperCase() + id.slice(1);
  return {
    maxId: 'max' + titleCaseId,
    minId: 'min' + titleCaseId
  };
};

const MinMaxSelectRedux = (props) => {
  const { minId, maxId } = getMinMaxId(props.id);

  const dispatch = useDispatch();
  const min = useSelector((state) => state.searchFilters[minId]);
  const max = useSelector((state) => state.searchFilters[maxId]);

  // ---------------------------------------------------------

  const onChangeMinMax = ({ min, max }) => {
    if (parseInt(min) < parseInt(max)) {
      dispatch(updateSingleFilter({ group: minId, value: min }));
      dispatch(updateSingleFilter({ group: maxId, value: max }));
    }
  };

  // ---------------------------------------------------------

  return <MinMaxSelect {...props} onChangeMinMax={onChangeMinMax} min={min} max={max} />;
};

// ---------------------------------------------------------

MinMaxSelectRedux.propTypes = {
  /**
   * Id to create the min/max key to to serve as the location where to store the values
   * in the redux store
   */
  id: PropTypes.string.isRequired
};

export default MinMaxSelectRedux;
